// extracted by mini-css-extract-plugin
module.exports = {"storyblok-category-info-text__card":"StoryblokCategoryInfoText_storyblok-category-info-text__card__WA7G1"};